// `video.template`: a run of one of live's video templates (G14). Started by its template's form on
// the Templates page, never a Studio draft; it lists there, in My Generations.
import { VideoTemplateQuote, VideoTemplateRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.template"> = {
  type: "video.template",
  label: "Template",
  source: "form",
  pair: "video.template",
  fields: () => ({}),
  request: VideoTemplateRequest,
  quote: VideoTemplateQuote,
};
